/** @file An animation name without its `@DIR` suffix (the base a direction variant belongs to). */

/** `walk@SE` -> `walk`; a plain name is returned as is. */
export function baseName(name: string): string {
  const at = name.indexOf('@');
  return at < 0 ? name : name.slice(0, at);
}
